import { Card, makeStyles, Text } from "@fluentui/react-components";
import { LayerRegular } from '@fluentui/react-icons';

const popularArticles = [
  {
    title: "Update the license count",
    url: "https://support.o365hq.com/portal/en/kb/articles/update-the-license-count"
  },
  {
    title: "Recommended steps to take if an account is compromised",
    url: "https://support.o365hq.com/portal/en/kb/articles/recommended-steps-to-take-if-an-account-is-compromised"
  },
  {
    title: "How to send an email as an attachment",
    url: "https://support.o365hq.com/portal/en/kb/articles/how-to-send-an-email-as-an-attachment"
  },
  {
    title: "How to Open and Use a Shared Mailbox in Outlook on the Web",
    url: "https://support.o365hq.com/portal/en/kb/articles/how-to-open-and-use-a-shared-mailbox-in-outlook-on-the-web"
  },
  {
    title: "Service Layer Agreement (SLA)",
    url: "https://support.o365hq.com/portal/en/kb/articles/sla"
  }
];

const useStyles = makeStyles({
  header: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    paddingBlock: "0.5em",
    borderBottom: "1px solid #eaeaea",
  }
});

export type PopularArticlesProps = {
    className?: string;
}

export const PopularArticles = (props: PopularArticlesProps) => {
  const styles = useStyles();
  return (
    <Card className={props.className} style={{ padding: "1em" }}>
      <Text className={styles.header} weight="semibold" size={400}>
        <LayerRegular/> Popular Articles
      </Text>
      <ul style={{ paddingLeft: "1em", margin: 0 }}>
        {popularArticles.map((article, index) => (
          <li key={index} style={{ marginBottom: "0.5em" }}>
            <a href={article.url} target="_blank" rel="noopener noreferrer" style={{ color: "#0067b8", textDecoration: "none" }}>
              {article.title}
            </a>
          </li>
        ))}
      </ul>
    </Card>
  );
};
